import { useEffect } from 'react';
import { useVeloraStore } from '../store/useVeloraStore';

export default function AchievementToast() {
  const { pendingAchievement, dismissAchievement } = useVeloraStore();

  useEffect(() => {
    if (!pendingAchievement) return;
    const t = setTimeout(dismissAchievement, 4000);
    return () => clearTimeout(t);
  }, [pendingAchievement, dismissAchievement]);

  if (!pendingAchievement) return null;

  return (
    <>
      <style>{`
        @keyframes achCenter {
          0%   { opacity:0;  transform:translate(-50%,-50%) scale(.3) }
          14%  { opacity:1;  transform:translate(-50%,-50%) scale(1.05) }
          20%  { transform:translate(-50%,-50%) scale(.97) }
          26%  { transform:translate(-50%,-50%) scale(1.01) }
          32%  { transform:translate(-50%,-50%) scale(1) }
          68%  { opacity:1;  transform:translate(-50%,-50%) scale(1) }
          100% { opacity:0;  transform:translate(-50%,-50%) scale(.90) }
        }
        @keyframes shimmerAch {
          0%   { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
      `}</style>
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        zIndex: 9999, textAlign: 'center', pointerEvents: 'none',
        animation: 'achCenter 3.2s cubic-bezier(.22,1,.36,1) forwards',
      }}>
        <div style={{
          background: 'rgba(255,255,255,0.08)',
          backdropFilter: 'blur(40px) saturate(200%)',
          WebkitBackdropFilter: 'blur(40px) saturate(200%)',
          border: '1px solid rgba(255,255,255,0.16)',
          borderRadius: 28,
          padding: '32px 44px',
          boxShadow: '0 0 60px rgba(127,119,221,0.25), 0 24px 64px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.18)',
          position: 'relative',
          overflow: 'hidden',
        }}>
          {/* Glass shine */}
          <div style={{
            position: 'absolute', inset: 0, borderRadius: 28,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 50%)',
            pointerEvents: 'none',
          }} />
          {/* Glow behind icon */}
          <div style={{
            position: 'absolute', top: '20%', left: '50%', transform: 'translateX(-50%)',
            width: 80, height: 80, borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(127,119,221,0.4), transparent 70%)',
            filter: 'blur(16px)', pointerEvents: 'none',
          }} />
          <div style={{ fontSize: 64, lineHeight: 1, marginBottom: 12, position: 'relative' }}>
            {pendingAchievement.icon}
          </div>
          <div style={{
            fontSize: 10, letterSpacing: 3, color: 'rgba(155,148,232,0.8)',
            fontWeight: 700, textTransform: 'uppercase', marginBottom: 8,
            fontFamily: 'Syne, sans-serif', position: 'relative',
          }}>Achievement</div>
          <div style={{
            fontSize: 20, fontWeight: 800, color: '#EEEDFE', marginBottom: 4,
            fontFamily: 'Syne, sans-serif', position: 'relative',
          }}>{pendingAchievement.label}</div>
          <div style={{ fontSize: 12, color: 'rgba(238,237,254,0.40)', position: 'relative' }}>
            {pendingAchievement.label}
          </div>
        </div>
      </div>
    </>
  );
}
